<div class="calendar__wrapper">
    <div class="calendar__label">{{ label }}</div>
    <div class="calendar__input-wrapper">
        <input
            [ngClass]="{
                select: selectedDate
            }"
            maxlength="4"
            class="calendar__input"
            [value]="selectedYear || ''"
            [name]="name"
            min={{MIN_YEAR}}
            max={{MAX_YEAR}}
            placeholder="YYYY"
            (input)="onYearInputChange($event)"
        />
        /
        <input
            [ngClass]="{
                select: selectedDate
            }"
            maxlength="2"
            class="calendar__input"
            [value]="selectedMonth || ''"
            [name]="name"
            placeholder="MM"
            (input)="onMonthInputChange($event)"
        />
        /
        <input
            [ngClass]="{
                select: selectedDate
            }"
            maxlength="2"
            class="calendar__input"
            [value]="selectedDay || ''"
            [name]="name"
            placeholder="DD"
            (input)="onDayInputChange($event)"
        />
        <div
            (click)="toggleCalendar()"
            class="icon_calendar"
            alt="calendar icon"
        ></div>
    </div>
</div>
<div
    *ngIf="calendarHasErrors()"
    style="max-width: 216px"
    class="error-container text light"
>
    <mat-icon svgIcon="error" class="error-icon"></mat-icon>
    <span>
        {{ getErrorMessage() | translate: { min: MIN_YEAR, max: MAX_YEAR } }}
    </span>
</div>
<div class="calendar" #calendar *ngIf="show" [@fadeInOut]>
    <div class="calendar__navs">
        <div class="calendar__month-nav">
            <button
                class="calendar__nav-btn right-arrows"
                (click)="prevYear()"
            ></button>
            <button
                class="calendar__nav-btn right-arrow"
                (click)="prevMonth()"
            ></button>
            <span>
                {{ currentDate.format("MMMM").slice(0, 3) }}
                {{ currentDate.format("YYYY") }}
            </span>
            <button
                class="calendar__nav-btn left-arrow"
                (click)="nextMonth()"
            ></button>
            <button
                class="calendar__nav-btn left-arrows"
                (click)="nextYear()"
            ></button>
        </div>
    </div>
    <div class="calendar__month">
        <div class="calendar__day-names">
            <div class="calendar__day-name" *ngFor="let name of namesOfDays">
                {{ name }}
            </div>
        </div>
        <div class="calendar__weeks">
            <div class="calendar__week" *ngFor="let week of weeks">
                <ng-container *ngFor="let day of week">
                    <div
                        class="calendar__date"
                        [ngClass]="{
                            today: day.today,
                            selected: isSelected(day.mDate),
                            disabled: !isSelectedMonth(day.mDate)
                        }"
                        (click)="
                            isSelectedMonth(day.mDate) ? selectDate(day) : null
                        "
                    >
                        <span class="calendar__number">{{
                            day.mDate.date()
                        }}</span>
                    </div>
                </ng-container>
            </div>
        </div>
        <div class="calendar__btn-container">
            <div class="cancel-btn" (click)="cancel()">Cancel</div>
            <div class="calendar__btn" (click)="ok()">Ok</div>
        </div>
    </div>
</div>
